import React from 'react';
import {Button, TextField} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    placeholder: string,
    field: string,
    handleChange: (val: any) => void,
    width?: string,
    name?: string,
    values: any,
    handleSubmit: () => void,
    handleClear: () => void


}

const CustomSearch: React.FC<Props> = ({
                                           placeholder,
                                           field,
                                           handleChange,
                                           width = "200px",
                                           values,
                                           handleSubmit,
                                           handleClear
                                       }) => {
    return (
        <>
            <TextField
                id={field}
                name={field}
                value={values[`${field}`]}
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder={placeholder}
                sx={{
                    input: {
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "17px",
                        letterSpacing: "0.02em",
                        width: width,
                        backgroundColor: "#f6f5f5",
                        color: "text.disabled",
                    },
                }}

            />
            <Button variant={"contained"}
                    sx={{height: "40px", borderRadius: 0, border: "none", backgroundColor: "secondary.main"}}
                    onClick={handleSubmit}>
                <SearchIcon/>
            </Button>
            <Button variant={"contained"}
                    sx={{height: "40px", borderRadius: 0, border: "none", backgroundColor: "secondary.main"}}
                    onClick={handleClear}>
                <CloseIcon/>
            </Button>

        </>
    );
};

export default CustomSearch;